export default __webpack_public_path__ + "static/media/132050489_2752296628326945_714763355050896255_n.17078bc7.jpg";